/*
 *                +-------------------+
 *                |  PROVIDING_MSISDN |
 *                +-+-------------+---+
 *                  | ^           | ^
 *                  v |           v |
 * +------------------++        +---+----------------+
 * | SUBMITTING_MSISDN |<-------+ COMPLETING_CAPTCHA |
 * +---------+---------+        +--------------------+
 *           |
 *           v
 *  +---------------+
 *  | GENERIC_ERROR |
 *  +---------------+
 *
 * La home du parcours rechargement peut-être dans les différents états suivant:
 * - PROVIDING_MSISDN : état initial, l'utilisateur tape des chiffres dans le champ input "numéro de téléphone"
 * - COMPLETING_CAPTCHA : le numéro tapé par l'utilisateur a un format valide (ex 06 XX XX XX XX)
 *                        un captcha s'affiche avant de pouvoir continuer et l'utilisateur doit compléter le captcha
 * - SUBMITTING_MSISDN : l'utilisateur a passé la validation front, le numéro de téléphone est soumis.
 * - GENERIC_ERROR : erreur technique, suite à la soumission du numéro de téléphone
 */

const HomeState = {
    PROVIDING_MSISDN: "providing-msisdn",
    SUBMITTING_MSISDN: "submitting-msisdn",
    COMPLETING_CAPTCHA: "completing-captcha",
    GENERIC_ERROR: "generic-error",
}

let vm = new Vue({
    el: '#refill-home',
    data: function () {
        return {
            labels: dto.labels,
            images: dto.images,
            phoneNumber: "",
            refillApiBaseUrl: dto.refillApiBaseUrl,
            captchaApiBaseUrl: dto.captchaApiBaseUrl,
            selectorPageUrl: dto.selectorPageUrl,
            contractualDocument: dto.contractualDocument,
            state: HomeState.PROVIDING_MSISDN,
            isMsisdnValid: true,        // Numéro de téléphone est valide s'il fait 10 digits + commence par 06/07
            isMsisdnEligible: true,     // Retour de l'api,
            useCaptcha: dto.useCaptcha  // true si on a besoin d'un captcha, false sinon.
        }
    },
    computed: {
        isMsisdnProviding() {
            return this.state === HomeState.PROVIDING_MSISDN;
        },
        isMsisdnSubmitting() {
            return this.state === HomeState.SUBMITTING_MSISDN;
        },
        isGenericErrorDisplayed() {
            return this.state === HomeState.GENERIC_ERROR;
        },
        isMsisdnErrorDisplayed() {
            return !this.isMsisdnValid || !this.isMsisdnEligible;
        },
        isCaptchaDisplayed() {
            return this.state === HomeState.COMPLETING_CAPTCHA;
        },
        isMsisdnEmpty() {
          return this.phoneNumber.length === 0;
        },
        msisdnErrorLabel() {
            if (!this.isMsisdnValid) {
                return this.labels.incompleteErrorLabel;
            } else if (!this.isMsisdnEligible) {
                return this.labels.refillErrorLabel;
            } else {
                return null;
            }
        },
    },
    methods: {
        onInput(event) {
            if (!this.isMsisdnValid || !this.isMsisdnEligible) {
                this.isMsisdnValid = true;
                this.isMsisdnEligible = true;
            }
            // L'utilisateur change le numéro de téléphone saisi,
            // on repasse dans l'état de saisie (même si le captcha est présent par exemple).
            // On réinitialise la sélection éventuelle du captcha.
            this.state = HomeState.PROVIDING_MSISDN;
            if (this.useCaptcha) {
                const captcha = this.$refs["captcha"];
                captcha.resetSelection();
            }

            // On regarde si l'input est constitué uniquement de digit.
            // Si c'est le cas, on formatte en XX XX XX XX XX
            const inputPhoneNumber = event.target.value;
            const normalizedPhoneNumber = this.getNormalizedPhoneNumber(inputPhoneNumber);
            const re = /^\d*$/;
            let displayedMsisdn;
            if (re.test(normalizedPhoneNumber)) {
                displayedMsisdn = this.getFormattedPhoneNumber(inputPhoneNumber);
            } else {
                displayedMsisdn = inputPhoneNumber;
            }
            // Dès que le numéro entré est un numéro valide, on affiche
            // le captcha si besoin.
            if (this.isMsisdnFormatValid(displayedMsisdn) && this.useCaptcha) {
                this.state = HomeState.COMPLETING_CAPTCHA;
            }
            return displayedMsisdn;
        },
        isMsisdnFormatValid(phoneNumer) {
            const msisdn = this.getNormalizedPhoneNumber(phoneNumer);
            const re = /^0[6-7]\d{8}$/;
            return re.test(msisdn);
        },
        fetchRefill(msisdn) {
            const normalizedMsisdn = this.getNormalizedPhoneNumber(msisdn);
            this.isMsisdnValid = true;
            this.isMsisdnEligible = true;
            this.state = HomeState.SUBMITTING_MSISDN;
            const body = {
                msisdn: normalizedMsisdn
            };
            $.ajax({
                method: "POST",
                url: this.refillApiBaseUrl,
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done((data) => {
                window.location = this.selectorPageUrl;
            }).fail((xhr) => {
                if (this.useCaptcha) {
                    // On met à jour le captcha
                    this.$refs["captcha"].loadCaptcha();
                }

                if (xhr.status === 400 || xhr.status === 404 || xhr.status === 412) {
                    this.state = HomeState.PROVIDING_MSISDN;
                    this.isMsisdnEligible = false;
                } else {
                    this.state = HomeState.GENERIC_ERROR;
                }
            });
        },
        onContinueButtonClick() {
            this.validate();
            if (!this.isMsisdnValid) {
                return;
            }
            this.fetchRefill(this.phoneNumber);
        },
        onCaptchaValid() {
            this.fetchRefill(this.phoneNumber);
        },
        onCaptchaError() {
            this.state = HomeState.GENERIC_ERROR;
        },
        validate() {
            this.isMsisdnValid = this.isMsisdnFormatValid(this.phoneNumber);
        },
        getFormattedPhoneNumber(value) {
            const valueNormalized = this.getNormalizedPhoneNumber(value).substring(0, 10);
            const tokens = this.chunk(valueNormalized, 2);
            return tokens.join(" ");
        },
        getNormalizedPhoneNumber(value) {
            return value.replace(/\s/g, "")
        },
        chunk(str, n) {
            let ret = [];
            for (let i = 0, len = str.length; i < len; i += n) {
                ret.push(str.slice(i, i+n));
            }
            return ret
        }
    },
    template: `
        <div>

            <!-- Bandeau titre -->
            <div class="container-fluid">
                <div class="row py-0">
                    <div class="col-12 col-md-10 col-xl-8 mx-auto">
                        <div class="d-flex align-items-center mt-0 text-white bg-dark">
                            <div class="flex-shrink-0">
                                <img
                                    class="align-self-center mx-1 my-1"
                                    alt=""
                                    :src="images.bannerIcon.src"
                                    :srcset="images.bannerIcon.srcSet"
                                />
                            </div>
                            <div class="align-self-center flex-grow-1">
                                <p class="text-mw lead my-1 me-3">{{ labels.bannerText }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Text field, bouton, captcha, reassurance -->
            <div class="container-fluid">

                <div class="row">

                    <div class="col-12 col-md-10 col-xl-8 mx-auto boosted-max-width">

                        <!-- Input et boutons -->
                        <div class="row mt-4 mb-2">
                            <div class="col-12 d-flex">
                                <form v-on:submit.prevent autocomplete="off">
                                    <div class="ob1-form-group">
                                        <input
                                            :value="phoneNumber"
                                            @input="phoneNumber=onInput($event)"
                                            type="text"
                                            :data-ob1-component="isMsisdnEmpty ? 'FormControlEmpty' : null"
                                            class="form-control ob1-form-control-small"
                                            :class="{'is-invalid': isMsisdnErrorDisplayed, 'form-control-empty': isMsisdnEmpty}"
                                            id="phone-number-input"
                                            aria-describedby="phone-number-label"
                                            maxlength="14"
                                        >
                                        <label id="phone-number-label" class="form-control-placeholder" for="phone-number-input">{{labels.phoneNumberInputPlaceholder}}</label>
                                        <div class="alert-container alert-container-sm alert-danger invalid-feedback">
                                            <p class="alert">
                                                <span class="alert-icon" aria-hidden="true"></span>
                                                <label class="ob1-alert-title" id="phonenumber-feedback" for="phone-number-input">{{ msisdnErrorLabel }}</label>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                                <div v-if="isMsisdnFormatValid(phoneNumber) && !isMsisdnErrorDisplayed" class="ms-2 phone-number-tick">
                                    <span class="icon icon-tick-circle" aria-hidden="true"></span>
                                </div>
                            </div>
                        </div>

                        <template v-if="useCaptcha">
                            <captcha
                                v-show="isCaptchaDisplayed"
                                :captcha-api-base-url="captchaApiBaseUrl"
                                ref="captcha"
                                @captcha-valid="onCaptchaValid"
                                @captcha-error="onCaptchaError"
                            />
                        </template>

                        <div class="row my-2">
                            <div v-if="isMsisdnProviding" class="col-12">
                                <button
                                    type="button"
                                    class="btn btn-primary"
                                    @click="onContinueButtonClick"
                                >{{ labels.continueButtonLabel }}
                                </button>
                            </div>
                            <div v-if="isMsisdnSubmitting" class="d-flex justify-content-center m-1">
                                <ob1-progress-indicators :size="50" type="undetermined" class="my-auto"/>
                            </div>
                        </div>

                        <ob1-message-alerte v-if="isGenericErrorDisplayed" id="alert-sucess-message" class="pb-1"
                                            :title="labels.genericErrorTitle"
                                            :text="labels.genericErrorDescription"
                                            :is-simple-alerte="false"
                                             type="warning">
                        </ob1-message-alerte>

                        <refill-reassurance
                            :icons="['icon-clock', 'icon-lock']"
                            :labels="labels.reassuranceLabels"
                        />

                        <!-- Jeu -->
                        <div class="game row mx-0 my-4">
                            <div class="col-12">
                                <refill-game :image="images.gameBanner"/>
                            </div>
                        </div>
                        <!-- lien vers toutes les recharges -->
                        <div class="row mx-0 mt-4">
                            <ob1-liens
                                :text="labels.linkText"
                                :href="labels.linkUrl"
                                :with-arrow="true"
                            >
                            </ob1-liens>
                        </div>
                    </div>

                </div>
            </div>

            <!-- lien doc contractuel -->
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 col-md-10 col-xl-8 mx-auto mb-1">
                        <a
                            :href="contractualDocument.contractualDocumentLink"
                            target="_blank"
                            class="ob1-link-arrow max-width-none"
                        >{{ labels.downloadContratLabel }}</a>
                    </div>
                </div>
            </div>

            <!-- Mentions legales -->
            <refill-legal-mention
                :contractual-document="contractualDocument"
            />
        </div>
    `
});
